import { ApiPermissions } from "../cefi";

export type FeaturesKeys = "send" | "trade" | "receive" | "limit_trade";

export const featureKeyToPermission: Record<FeaturesKeys, ApiPermissions> = {
  send: ApiPermissions.WITHDRAW,
  trade: ApiPermissions.TRADE,
  receive: ApiPermissions.READ,
  limit_trade: ApiPermissions.TRADE,
};
